import { MAKEUP_V3_BRIDAL_LOOKS } from '../utils/makeupV3BridalLooks';

export default function MakeupV3BridalLooksGrid({
  selectedLookId,
  onSelectLook,
  disabled = false,
  looks = null,
  showHeading = true,
}) {
  const list = looks || MAKEUP_V3_BRIDAL_LOOKS;
  return (
    <div className="makeup-v3-bridal-looks">
      {showHeading ? (
        <p className="makeup-v3-bridal-looks__heading">Select a bridal look</p>
      ) : null}
      <div className="makeup-v3-bridal-looks__grid" role="list">
        {list.map((look) => {
          const selected = selectedLookId === look.id;
          return (
            <button
              key={look.id}
              type="button"
              role="listitem"
              className={`makeup-v3-bridal-looks__card${selected ? ' is-selected' : ''}`}
              disabled={disabled}
              onClick={() => onSelectLook(look.id)}
              aria-label={look.label}
              aria-pressed={selected}
            >
              <div className="makeup-v3-bridal-looks__thumb" aria-hidden="true">
                <span className="makeup-v3-bridal-looks__thumb-letter">
                  {look.label.charAt(0)}
                </span>
              </div>
              <strong className="makeup-v3-bridal-looks__title">{look.label}</strong>
              <span className="makeup-v3-bridal-looks__subtitle">{look.subtitle}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
